import React from "react";
import { NavLink } from "react-router-dom";
import { List, ListItem, Logo, LogoImg, Nav, Navbar } from "./Sidebar.styles";

import LogoImage from "../../assets/images/logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faHome,
  faUser,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faGithub,
  faInstagram,
  faTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

const Sidebar = () => {
  return (
    <Navbar>
      <Logo to="/">
        <LogoImg src={LogoImage} alt="logo" />
      </Logo>
      <Nav>
        <NavLink
          exact={`true`}
          className={(navData) => (navData.isActive ? "active" : null)}
          to="/"
        >
          <FontAwesomeIcon icon={faHome} color="#4d4d4d" />
        </NavLink>
        <NavLink
          exact={`true`}
          className={(navData) =>
            navData.isActive ? "active about-link" : "about-link"
          }
          to="/about"
        >
          <FontAwesomeIcon icon={faUser} color="#4d4d4d" />
        </NavLink>
        <NavLink
          exact={`true`}
          className={(navData) =>
            navData.isActive ? "active projects-link" : "projects-link"
          }
          to="/projects"
        >
          <FontAwesomeIcon icon={faBriefcase} color="#4d4d4d" />
        </NavLink>
        <NavLink
          exact={`true`}
          className={(navData) =>
            navData.isActive ? "active contact-link" : "contact-link"
          }
          to="/contact"
        >
          <FontAwesomeIcon icon={faEnvelope} color="#4d4d4d" />
        </NavLink>
      </Nav>
      <List>
        <ListItem>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/ayah1996"
          >
            <FontAwesomeIcon icon={faGithub} color="#4d4d4d" />
          </a>
        </ListItem>
        <ListItem>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/ayahezzeddine/"
          >
            <FontAwesomeIcon icon={faLinkedin} color="#4d4d4d" />
          </a>
        </ListItem>

        <ListItem>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/ayah.ezzeddine/"
          >
            <FontAwesomeIcon icon={faInstagram} color="#4d4d4d" />
          </a>
        </ListItem>
        <ListItem>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/ayah.ezzeddine96"
          >
            <FontAwesomeIcon icon={faFacebook} color="#4d4d4d" />
          </a>
        </ListItem>
        <ListItem>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/ayah__ezzeddine"
          >
            <FontAwesomeIcon icon={faTwitter} color="#4d4d4d" />
          </a>
        </ListItem>
      </List>
    </Navbar>
  );
};

export default Sidebar;
